import { useDispatch } from "react-redux";
import allTabs from "../../pages/DashboardTabs"
import { useNavigate } from 'react-router-dom';
import systemSlice from "../../redux/systemSlice";


const useCustomNavigate = (tab: any) => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const goBack = () => {
        const tabs = tab?.activeTabs
        const tabsLength = tabs.length
        const secondLastTabId = tabs[tabsLength - 2]
        if (secondLastTabId) {
            const tabData = allTabs.find(tab => tab.id === secondLastTabId)

            dispatch(systemSlice.actions.handleActiveSubTabs({ tabId: secondLastTabId, isClose: true }));

            setTimeout(() => {
                navigate(tabData.pointTo)
            }, 350)
        }

    }

    return goBack
}
export default useCustomNavigate